import teamProfileImage from '../images/avatar.png';
import { useState, useEffect } from 'react';
import createClient from '../Client';
import { PortableText } from '@portabletext/react';

const serializers = {

    marks: {
        link: ({ children, value }) => {
            const rel = !value.href.startsWith('/') ? 'noreferrer noopener' : undefined
            const target = '_blank'
            const className = 'link'

            return (
                <a href={value.href} rel={rel} target={target} className={className}>
                    {children}
                </a>
            )
        },
    },
};

//repreater block wrapper
const TeamProfile = () => {
    const [modal, setModal] = useState(false);
    const [selectedProfile, setSelectedProfile] = useState(null);
    const [TeamData, setTeamData] = useState([]);

    const openModal = (profile) => {
        setSelectedProfile(profile);
        setModal(!modal);
    };

    const closeModal = () => {
        setSelectedProfile(null);
        setModal(false);
    };

    useEffect(() => {
        // Add or remove the class from the html element based on isOpen state
        if (modal) {
            document.documentElement.classList.add('overflow-hidden');
        } else {
            document.documentElement.classList.remove('overflow-hidden');
        }

        // Cleanup function to remove class when component unmounts
        return () => {
            document.documentElement.classList.remove('overflow-hidden');
        };
    }, [modal]);

    useEffect(() => {
        createClient.fetch(`*[_type == 'team' && !(_id in path('drafts.**'))] | order(_createdAt asc){
            "id" : _id,
            "teamImage":team_featured_image.asset->url,
            "name":team_title,
            "designation": team_designation,
            "descrption" : content
        }`).then((data) => {
            setTeamData(data);
        })
            .catch(console.error);
    }, [])

    return (
        <>
            <section className="profile-wrapper text-center p-top-70">
                <div className="container">
                    <div className="row">
                        {TeamData.map((profile) => (
                            <div key={profile.id} className="col-sm-6 col-md-6 col-lg-4 m-b-30">
                                <div className="profile-outer-wrap text-center" onClick={() => openModal(profile)}>
                                    <div className="profileContentWrapper">
                                        <div className="teamProfileImage">
                                            <img src={profile.teamImage ? profile.teamImage : teamProfileImage} alt={profile.name} />
                                        </div>
                                        <div className="teamProfileContent">
                                            <h3>
                                                <span>{profile.name}</span>
                                            </h3>
                                            <span>{profile.designation}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <div className={`overlay-bg ${modal ? 'open' : ''}`}>
                <div className={`sidebar ${modal ? 'open' : ''}`}>
                    <button className="sidebar-close-btn" onClick={closeModal}>
                        &times;
                    </button>
                    {modal ? (
                        <>
                            <div className='popup-head'>
                                <div className='profile-popup-img'>
                                    <img src={selectedProfile.teamImage ? selectedProfile.teamImage : teamProfileImage} alt={selectedProfile.name}></img>
                                </div>
                                <h4>{selectedProfile.name}</h4>
                                <p>{selectedProfile.designation}</p>
                            </div>
                            <p><PortableText value={selectedProfile.descrption} components={serializers} ></PortableText></p>
                        </>
                    ) : null}

                </div>
            </div>


        </>
    );
}

export default TeamProfile;